module.exports = __webpack_public_path__ + "static/arrow-075b8e82153d2b015c6c1290ff061b5b.svg";